import axios from "../http";

class UserManage {
  //所有权限列表
  getAuthorityList() {
    const url = `/oa/api/authority/manager/all`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //拥有的权限
  getManagerAuthority(managerId) {
    const url = `/oa/api/authority/manager/list?managerId=${managerId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //保存权限
  postUpdateAuthority(data) {
    const url = `/oa/api/authority/manager/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //管理员可以看的菜单
  getManagerMenu() {
    const url = `/oa/api/authority/manager/info`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //管理员列表
  getManagerList(name) {
    const url = `/oa/api/pc/manager/list?name=${name}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增管理员
  postAddManager(data) {
    const url = `/oa/api/pc/manager/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //编辑管理员
  postUpdateManager(data) {
    const url = `/oa/api/pc/manager/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //编辑 启用/禁用
  postUpdateManagerStatus(data) {
    const url = `/oa/api/pc/manager/update/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default UserManage;
